import React, { useCallback } from 'react'
import ListPage from '../../Components/List/ListPage'
import DropdownGroup from '../../Components/Dropdown/DropdownGroup'
import DropdownItem from '../../Components/Dropdown/DropdownItem'
import {ColInfo, ColOptions, ColPhoto, ColSelect, ColStat,} from '../../Components/List/Col'
import Dropdown from '../../Components/Dropdown'
import {ButtonIcon} from '../../Components/Button/Button'
import styles from '../../../CSS/main.css'
import SitesItem, {Website} from '../../Components/List/Item/SitesItem'
import {useNavigation} from '../../utils/navigation'
import {useListState} from '../../Components/List/hooks'
import {INIT_WEBSITE_STATE, WEBSITE_FILTERS, WEBSITE_STATE, WEBSITE_TABS} from './filters'
import {Filters} from '../../Components/Filters'
import {getWebsites} from "../../api/requests";
import { Routes } from '../../routing'

const Websites: React.VFC = () => {
  const { goBack } = useNavigation()

  const {
    params,
    setActiveTab,
    onPageChange,
    select,
    toggleAll,
    selectedItems,
    onChangeSearch,
    setListParams,
    resetState,
    items,
    pageCount,
    loading,
    allSelected,
  } = useListState<Website, WEBSITE_STATE>(INIT_WEBSITE_STATE, getWebsites)
  const { page, tab, searchTerm } = params
  const { goTo } = useNavigation()

  const navigateToSite = useCallback((name: string) => {
    goTo(Routes.EditWebsite, { id: encodeURIComponent(name) })
  }, [])

  return (
    <ListPage
      loading={loading}
      items={items}
      searchTerm={searchTerm}
      onChangeSearch={onChangeSearch}
      filters={(toggle) => (
        <Filters
          filters={WEBSITE_FILTERS}
          filterState={params}
          updateParams={setListParams}
          onReset={resetState}
          onClose={toggle}
        />
      )}
      itemRenderer={(i) => (
        <SitesItem
          key={i.name}
          onSelected={() => select(i)}
          selected={selectedItems.includes(i)}
          website={i}
          options={
            <>
              <DropdownGroup>
                <DropdownItem onClick={() => navigateToSite(i.name)}>More Info</DropdownItem>
              </DropdownGroup>
            </>
          }
        />
      )}
      headerRenderer={() => (
        <>
          <ColSelect
            onChange={toggleAll}
            showActions={!!selectedItems.length}
            toggle={allSelected}>
            <Dropdown
              trigger={
                <ButtonIcon
                  title='Select Options'
                  additionalClassNames={[styles.SelectOptions]}
                />
              }
              position={'bottom'}>
              <DropdownGroup>
                <DropdownItem>Enable selected</DropdownItem>
                <DropdownItem>Disable selected</DropdownItem>
              </DropdownGroup>
              <DropdownGroup>
                <DropdownItem highlighted onClick={() => null}>
                  Delete selected
                </DropdownItem>
              </DropdownGroup>
            </Dropdown>
          </ColSelect>
          <ColPhoto />
          <ColInfo>
            <a href='#'>Site name</a>
          </ColInfo>
          <ColStat>
            <a href='#'>Status</a>
          </ColStat>
          <ColOptions />
        </>
      )}
      title={'Manage Websites'}
      onBack={goBack}
      tabs={WEBSITE_TABS}
      activeTab={tab}
      onChangeTab={setActiveTab}
      pageCount={pageCount}
      page={page}
      onPageChange={onPageChange}
    />
  )
}

export default Websites
